var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_19048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.028 1.99951C16.4305 1.99951 19.999 5.56801 19.999 9.97051V13.1715C19.999 13.7025 20.209 14.211 20.5855 14.586L21.586 15.5865C21.8515 15.852 22 16.212 22 16.587C22 17.3685 21.367 18.0015 20.5855 18.0015H16C16 20.211 14.209 22.002 11.9995 22.002C9.79002 22.002 7.99902 20.208 7.99902 18H3.40302C2.62752 18 1.99902 17.3715 1.99902 16.596C1.99902 16.215 2.15352 15.8505 2.42802 15.5865L3.45702 14.592C3.84852 14.214 4.06902 13.692 4.06752 13.1475L4.05852 9.99451C4.04502 5.58301 7.61802 1.99951 12.0295 1.99951H12.028ZM13.999 18H9.99852C9.99852 19.104 10.894 19.9995 11.998 19.9995C13.102 19.9995 13.999 19.104 13.999 18ZM12.028 3.99901C11.2425 3.99901 10.4647 4.15402 9.73924 4.45517C9.01375 4.75631 8.35482 5.19767 7.80022 5.75394C7.24562 6.31022 6.80625 6.97047 6.50729 7.69686C6.20833 8.42326 6.05566 9.20151 6.05802 9.98701L6.06702 13.14C6.07002 14.214 5.64102 15.2445 4.87752 15.999H19.171C18.421 15.249 17.9995 14.232 17.9995 13.17V9.97051C17.9995 8.38717 17.3705 6.86868 16.2509 5.74908C15.1314 4.62949 13.6129 4.00051 12.0295 4.00051L12.028 3.99901Z",
    fill: "#6F767E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_19048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/SVG.133334d81b5b54925fd7b7b7644403d0.svg";
export { ForwardRef as ReactComponent };